import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../components/AdminHeader';
import { getBilling, BillingData } from '../services/billing';
import './AdminBillingPage.css';

const AdminBillingPage: React.FC = () => {
  const [billing, setBilling] = useState<BillingData | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadBilling();
  }, []);

  const loadBilling = async () => {
    setLoading(true);
    try {
      const data = await getBilling();
      setBilling(data);
    } catch (error) {
      console.error('Error loading billing:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price: number): string => {
    return `${price.toFixed(2)} €`;
  };

  return (
    <div>
      <AdminHeader />
      <div className="container">
        {loading ? (
          <div className="loading">Lade Abrechnungsdaten...</div>
        ) : billing ? (
          <>
            <div className="billing-summary">
              <h2>Zusammenfassung</h2>
              <div className="summary-cards">
                <div className="summary-card">
                  <h3>Letzter Monat</h3>
                  <p className="summary-label">{billing.period.lastMonth.label}</p>
                  <p className="summary-value">{formatPrice(billing.totals.lastMonth)}</p>
                </div>
                <div className="summary-card">
                  <h3>Aktueller Monat</h3>
                  <p className="summary-label">{billing.period.currentMonth.label}</p>
                  <p className="summary-value">{formatPrice(billing.totals.currentMonth)}</p>
                </div>
                <div className="summary-card">
                  <h3>Gesamtumsatz</h3>
                  <p className="summary-label">Alle Zeiten</p>
                  <p className="summary-value total">{formatPrice(billing.totals.overall)}</p>
                </div>
              </div>
            </div>

            <div className="billing-table-container">
              <h2>Umsatz pro Händler</h2>
              <table className="table">
                <thead>
                  <tr>
                    <th>Händler</th>
                    <th>E-Mail</th>
                    <th>Letzter Monat</th>
                    <th>Aktueller Monat</th>
                    <th>Gesamtumsatz</th>
                    <th>Gesamt Bestellungen</th>
                  </tr>
                </thead>
                <tbody>
                  {billing.dealers.length === 0 ? (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center' }}>
                        Keine Daten verfügbar
                      </td>
                    </tr>
                  ) : (
                    billing.dealers.map(dealerBilling => (
                      <tr key={dealerBilling.dealer.id}>
                        <td>
                          <strong>{dealerBilling.dealer.username}</strong>
                        </td>
                        <td>{dealerBilling.dealer.email}</td>
                        <td>
                          <div>
                            <strong>{formatPrice(dealerBilling.lastMonth.revenue)}</strong>
                            <div style={{ fontSize: '0.85em', color: '#666' }}>
                              {dealerBilling.lastMonth.orderCount} Bestellung
                              {dealerBilling.lastMonth.orderCount !== 1 ? 'en' : ''}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <strong>{formatPrice(dealerBilling.currentMonth.revenue)}</strong>
                            <div style={{ fontSize: '0.85em', color: '#666' }}>
                              {dealerBilling.currentMonth.orderCount} Bestellung
                              {dealerBilling.currentMonth.orderCount !== 1 ? 'en' : ''}
                            </div>
                          </div>
                        </td>
                        <td>
                          <strong style={{ fontSize: '1.1em', color: '#2c3e50' }}>
                            {formatPrice(dealerBilling.total.revenue)}
                          </strong>
                        </td>
                        <td>{dealerBilling.total.orderCount}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="error">Fehler beim Laden der Abrechnungsdaten</div>
        )}
      </div>
    </div>
  );
};

export default AdminBillingPage;
